import './home.css';
import Mainpage from './mainpage';
import News from './news';
import Topic from './topic';
import Subscribe from './subscribe';


function App() {
  return (
    <div>
      <Mainpage />
      <News />
      <Topic />
      <Subscribe />
    </div>
  );
}

export default App;
